var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticStyle:{"margin-top":"300px"}},[_vm._v("Editing Interface View")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"})])])
}]

export { render, staticRenderFns }